<template>
  <div
    class="team-member-description-card d-flex align-center elevation-1 rounded-sm gr-2"
  >
    <v-img
      class="flex-grow-0 mt-auto rounded-circle"
      lazy-src="/static/_v1/pd/pictures/stubs/person-photo.png"
      :alt="`${transDynamic(teamMember, `first_name,${language},${needTranslate}`)} ${transDynamic(teamMember, `last_name,${language},${needTranslate}`)} ${transDynamic(teamMember, `position,${language},${needTranslate}`)}`"
      :src="teamMember.photo.url"
      width="200"
      height="200"
    />
    <div class="d-flex flex-column gr-2">
      <h5 class="text-h5 text--text">
        {{ transDynamic(teamMember, `first_name,${language},${needTranslate}`) }}
        {{ transDynamic(teamMember, `last_name,${language},${needTranslate}`) }}
      </h5>
      <p class="text-body-2 text--text">
        {{ transDynamic(teamMember, `position,${language},${needTranslate}`) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore } from 'src/store'
import type { ContextStore, TeamMember } from 'src/components/pages/info/about-us/index/types'

const { language } = I18NextVue
const { context }: ContextStore = useContextStore()
const needTranslate = context.feature_flags.pd_l10n_footer_pages

defineProps<{
  teamMember: TeamMember
}>()
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.team-member-description-card {
  padding: 24px 80px;
  column-gap: 124px;
}
</style>
